import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const SUPPORTED_LOCALES = ['en', 'ar']
export const RTL_LOCALES = ['ar']
export const LOCALE_STORAGE_KEY = 'DONE_USER_LANGUAGE'

export function normalizeLocale (value) {
  const v = String(value == null ? '' : value).trim().toLowerCase()
  return SUPPORTED_LOCALES.indexOf(v) > -1 ? v : 'en'
}

/**
 * Resolved here, at module-evaluation time, rather than from the app bootstrap.
 * A few modules (utils/user-role.js, utils/utils.js) call i18n.t() while their
 * own module body runs, which happens before main.js gets a chance to execute —
 * so the locale has to be correct the moment this instance is constructed.
 */
function bootLocale () {
  try {
    if (typeof localStorage === 'undefined') return 'en'
    return normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY))
  } catch (e) {
    return 'en'
  }
}

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      messages[matched[1]] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: bootLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  // Arabic is incomplete for strings added after the last translation round;
  // fall back to English quietly instead of logging for every one of them.
  silentFallbackWarn: true
})
